import { LOCALES } from "@app/constants";
import { PageModel } from "@app/api/pagebuilder/page.model";
import { PlatformType } from "@app/constants/platform";
import { notFoundPage, notAvailablePage, permanentlyGonePage } from "../../pagebuilder/non-wp-pages/error-pages";

export interface IErrorPages {
  notFoundPage: () => Promise<PageModel>;
  unavailablePage: () => Promise<PageModel>;
  permanentlyGonePage: () => Promise<PageModel>;
}

export interface IBasePageInformation {
  errorPages: IErrorPages;
  shopPageUrlName: string;
  dealPageUrlName: string;
  productPageUrlName: string;
  locale: string;
  platformId: number;
  urlAddition: string;
  isOffline: boolean; // If the platform is offline, we want to show a 410 for all its pages.
}

export const setBasePageInformation = async (platformVersion: number): Promise<IBasePageInformation> => {
  switch (platformVersion) {
    case PlatformType.NETHERLANDS:
      return {
        locale: LOCALES.NL,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.NETHERLANDS,
        urlAddition: "",
        dealPageUrlName: "deals",
        shopPageUrlName: "winkels",
        productPageUrlName: "producten",
        isOffline: false
      };
    case PlatformType.BELGIANDUTCH:
      return {
        locale: LOCALES.BENL,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.BELGIANDUTCH,
        urlAddition: "",
        dealPageUrlName: "deals",
        shopPageUrlName: "winkels",
        productPageUrlName: "producten",
        isOffline: false
      };
    case PlatformType.BELGIANFRENCH:
      return {
        locale: LOCALES.BEFR,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.BELGIANFRENCH,
        urlAddition: "fr",
        dealPageUrlName: "offres",
        shopPageUrlName: "magasins",
        productPageUrlName: "produits",
        isOffline: false
      };
    case PlatformType.FRENCH:
      return {
        locale: LOCALES.FR,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.FRENCH,
        urlAddition: "fr",
        dealPageUrlName: "offres",
        shopPageUrlName: "magasins",
        productPageUrlName: "produits",
        isOffline: true
      };
    case PlatformType.LANDINGPAGE:
      return {
        locale: LOCALES.EN,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.LANDINGPAGE,
        urlAddition: "",
        dealPageUrlName: "deals",
        shopPageUrlName: "stores",
        productPageUrlName: "products",
        isOffline: true
      };
    case PlatformType.UNITED_KINGDOM:
      return {
        locale: LOCALES.EN,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.UNITED_KINGDOM,
        urlAddition: "uk",
        dealPageUrlName: "deals",
        shopPageUrlName: "stores",
        productPageUrlName: "products",
        isOffline: true
      };
    case PlatformType.GERMANY:
      return {
        locale: LOCALES.DE,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.GERMANY,
        urlAddition: "de",
        dealPageUrlName: "deals",
        shopPageUrlName: "shops",
        productPageUrlName: "produkte",
        isOffline: false
      };
    case PlatformType.SWEDEN:
      return {
        locale: LOCALES.SE,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.SWEDEN,
        urlAddition: "se",
        dealPageUrlName: "erbjudanden",
        shopPageUrlName: "butiker",
        productPageUrlName: "produkter",
        isOffline: true
      };

    case PlatformType.SPAIN:
      return {
        locale: LOCALES.ES,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.SPAIN,
        urlAddition: "es",
        dealPageUrlName: "ofertas",
        shopPageUrlName: "tiendas",
        productPageUrlName: "productos",
        isOffline: true
      };
    case PlatformType.ITALY:
      return {
        locale: LOCALES.IT,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.ITALY,
        urlAddition: "it",
        dealPageUrlName: "offerte",
        shopPageUrlName: "negozi",
        productPageUrlName: "prodotti",
        isOffline: true
      };
    default:
      return {
        locale: LOCALES.NL,
        errorPages: { notFoundPage: notFoundPage, unavailablePage: notAvailablePage, permanentlyGonePage },
        platformId: PlatformType.NETHERLANDS,
        urlAddition: "",
        dealPageUrlName: "deals",
        shopPageUrlName: "winkels",
        productPageUrlName: "producten",
        isOffline: false
      };
  }
};
